module.exports = __webpack_public_path__ + "img/symbol_2.37cd0f85.png";